import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import img1 from "../assets/images/img1.jpg";
import img2 from "../assets/images/img2.jpg";
import img3 from "../assets/images/img3.jpg";
import "./HeroSection.css";

const slides = [
  {
    id: 1,
    image: img1,
    title: "Here When You Need Us Most",
    subtitle:
      "Get quick, simple and convenient access to cash when you need it",
  },
  {
    id: 2,
    image: img2,
    title: "Flexible Loan Solutions",
    subtitle: "Tailored to fit your unique financial needs",
  },
  {
    id: 3,
    image: img3,
    title: "Reliable Finance Partner",
    subtitle: "Committed to your financial success",
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index) => setCurrent(index);

  return (
    <div className="font-serif relative w-full h-[700px] overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute w-full h-full transition-opacity duration-1000 ease-in-out ${
            index === current
              ? "opacity-100 z-20 zoom-out-bg"
              : "opacity-0 z-10"
          }`}
          style={{
            backgroundImage: `url(${slide.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat", // Added for clarity
          }}
        >
          {/*Overlay Layer */}
          <div className="absolute inset-0 bg-black/50"></div>
          <div
            className={`w-full h-full flex flex-col justify-center items-center text-white text-center px-4 ${
              index === current ? "slide-up-content" : "slide-down-content"
            }`}
          >
            <h1 className="text-lg md:text-3xl font-medium mb-4">
              {slide.title}
            </h1>
            <p className="text-sm md:text-md mb-6 max-w-xl">{slide.subtitle}</p>
            <button className="hover:bg-amber-500 text-white px-6 py-2 rounded border border-2-[#ffc300]">
              Find Out More
            </button>
          </div>
        </div>
      ))}

      {/* Arrows */}
      <button
        onClick={() =>
          setCurrent((current - 1 + slides.length) % slides.length)
        }
        className="absolute left-4 top-1/2 transform -translate-y-1/2 z-30 p-2 bg-amber-500 hover:bg-white rounded-full"
      >
        <ChevronLeft size={28} />
      </button>
      <button
        onClick={() => setCurrent((current + 1) % slides.length)}
        className="absolute right-4 top-1/2 transform -translate-y-1/2 z-30 p-2 bg-amber-500 hover:bg-white rounded-full"
      >
        <ChevronRight size={28} />
      </button>

      {/* Dots */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-30">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`w-3 h-3 rounded-full ${
              index === current ? "bg-amber-500" : "bg-white/50"
            }`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
